import { render, staticRenderFns } from "./invoicesVendor.vue?vue&type=template&id=59a651e7&"
import script from "./invoicesVendor.vue?vue&type=script&lang=js&"
export * from "./invoicesVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports